import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import * as Yup from 'yup'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/product/productContext'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import UserInvoices from '../Tabs/UserInvoices'
import Credits from '../Tabs/Credits'
import UserEmailLogs from '../Tabs/UserEmailLogs'
import UserNotifications from '../Tabs/UserNotifications'
import UserBidHistory from '../Tabs/UserBidHistory'
import UserSmsLogs from '../Tabs/UserSmsLogs'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import AuthContext from '@/product/context/auth/authContext'
import { useFormik } from 'formik'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
} from '@/custom/common/components'
import BaseActionPage from '@/product/components/species/dynamic/common/BaseActionPage'
import UserContext from '@/product/context/user/userContext'
import Loaders from '@/product/components/molecules/Loaders'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import ProductContext from '@/product/context/userProduct/productContext'
import BuyerBids from '../Tabs/BuyerBids'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import '../Tabs/Tabs.css'
import './Role.css'
import UserLogs from '../Tabs/LoginInfo'
import { Button, Menu, MenuItem } from '@mui/material'
import CustomDialog from '@/product/components/organisms/Dialog'
import ReportContext from '@/product/context/report/reportContext'
import MembershipLogs from '../Tabs/Membership'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const BuyerProfile = (props) => {
    const userContext = useContext(UserContext)
    const userProductContext = useContext(ProductContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { allCountries, allStates } = useContext(ProductCommonContext)
    const authContext = useContext(AuthContext)
    const reportContext = useContext(ReportContext)

    const {
        single_user,
        getSingleUser,
        userAction,
        changeUserStatus,
        responseStatus: responseStatusUser,
    } = userContext
    const { getAllExportDownload } = reportContext

    const { search_alldashboardproducts, getAllDashboardProducts } =
        userProductContext

    const {
        user,
        loadUser,
        updateProfile,
        responseStatus: responseStatus,
    } = authContext

    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [buttonData, setButtonData] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])

    const [resetMapData, setResetMapData] = useState(false)

    const [tableValue, setTableValue] = useState([])
    const [action, setAction] = useState('')
    const [userStatusOpen, setUserStatusOpen] = useState(false)
    const [formikValues, setFormikValues] = useState({})
    const [array, setArray] = useState([])

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])
    const [deletePopup, setDeletePopup] = useState(false)
    const [membershipPopup, setMembershipPopup] = useState(false)

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = props.customInitial

        customValidationTemp = {
            ...props.customValidation,
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            confirm_email:
                data.status === 'new'
                    ? Yup.string()
                          .email('Invalid email format')
                          .oneOf([Yup.ref('email')], "Email's not match")
                          .required('Required!')
                    : Yup.string(),
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only Numbers Are Allowed')
                .required('Required'),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Only numbers are allowed')
                .max(6, 'Maximum 6 characters')
                .min(5, 'Minimum 5 characters')
                .required('Required'),
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation, props.customInitial])

    // useEffect(() => {
    //     if (mapDataValueRef.current.length) {
    //         let tempMapData = mapDataValueRef.current
    //         tempMapData.map((mapValue) => {
    //             if (mapValue.name === 'date_closed') {
    //                 mapValue.minDate = dateTimeFormatFunction(
    //                     formikValues.date_added ? formikValues.date_added : null,
    //                 )
    //                 mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
    //                     formikValues.date_added ? formikValues.date_added : null,
    //                 )}`
    //                 mapValue.disablePast = true
    //             } else if (mapValue.name === 'date_added') {
    //                 mapValue.disablePast = true
    //             } else if (mapValue.name === 'sprice') {
    //                 mapValue.disabled = formikValues.auction ? false : true
    //             } else if (mapValue.name === 'rprice') {
    //                 mapValue.disabled = formikValues.auction ? false : true
    //             } else if (mapValue.name === 'bprice') {
    //                 mapValue.disabled = formikValues.buynow ? false : true
    //             }
    //         })
    //         setReload(!reload)
    //         // setMapDataValue(tempMapData)
    //         // setResetMapData(true)
    //     }
    // }, [formikValues])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = () => {
        const value = formikValues
        setIsLoading(true)
        userAction(value)
    }
    const formSubmit = (value, data) => {
        setFormikValues({
            ...formikValues,
            market_status: data,
        })
        submitFunction()
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
    }
    const closeUser = () => {
        setIsLoading(false)
        setUserModalOpen(false)
    }
    const notificationClose = () => {
        getSingleUser({ id: single_user?.record?.user_id })
        setNotifModalOpen(false)
        setIsLoading(true)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data.status !== 'edit') {
            if (data.status === 'new') {
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data.id])
    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.status === 'success') {
                if (responseStatusUser.from === 'changeStatus') {
                    setUserStatusOpen(false)
                    setIsLoading(true)
                    getSingleUser({ id: single_user?.record?.user_id })
                } else if (responseStatusUser.from === 'userAction') {
                    setUserModalOpen(false)
                    setMembershipPopup(false)
                    setIsLoading(true)
                    getSingleUser({ id: single_user?.record?.user_id })
                }
            } else {
                setUserStatusOpen(false)
            }
        }
    }, [responseStatusUser])

    const updateFunction = () => {
        getSingleUser({ id: single_user?.record?.user_id })
    }

    useEffect(() => {
        const buttonDataTemp = []
        if (formikValues.id) {
            if (formikValues.market_status === 'draft') {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: 'Save as Draft',
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Submit',
                    additionalValue: 'open',
                })
            }
            if (formikValues.market_status === '') {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            } else {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            }
        } else {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Submit',
                additionalValue: 'open',
            })
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status])

    const [value, setValue] = useState(0)

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        setValue(0)
    }, [data.popup])

    const notesValidation = Yup.object({
        reject_notes: Yup.string().required('Required'),
    })

    const notesFormik = useFormik({
        initialValues: {
            id: 0,
            email: '',
            reject_notes: '',
        },
        validationSchema: notesValidation,
        onSubmit: (values) => {
            userAction(values)
        },
    })

    const statusValidation = Yup.object({
        // reject_notes: Yup.string().required('Required'),
        action: Yup.string().required('Required'),
    })

    const formikStatus = useFormik({
        initialValues: {
            action: '',
            user_id: [],
            additionalUpdate: true,
            reject_notes: '',
            suspended: 0,
        },
        validationSchema: statusValidation,
        onSubmit: (values) => {
            console.log(values, 'suspee')
            changeUserStatus(values)
        },
    })

    const notesField = {
        formik: notesFormik,
        data: [
            {
                label: 'Notes',
                type: 'textarea',
                placeholder: 'Enter notes',
                class: 'col-12',
                name: 'reject_notes',
            },
        ],
    }

    useEffect(() => {
        if (single_user) {
            notesFormik.values.reject_notes = single_user.record.reject_notes
            notesFormik.values.id = single_user.record.id
            notesFormik.values.email = single_user.record.email
            formikStatus.values.action = single_user.record.status
            formikStatus.values.user_id = [single_user.record.user_id]
            formikStatus.values.reject_notes = single_user.record.reject_notes
            formikStatus.values.suspended = single_user.record.suspended
            setIsLoading(false)
        }
    }, [single_user])

    const custom = {
        user_id: {
            value: single_user?.record?.id,
            type: 'in',
            field: 'p.user_id',
        },
    }

    useEffect(() => {
        getAllDashboardProducts({
            limit: 12,
            page: 1,
            orderby: 'p.date_closed, asc',
            order: '',
            user_id: single_user?.record?.id,
            action: action,
        })
    }, [action])

    useEffect(() => {
        if (
            search_alldashboardproducts &&
            search_alldashboardproducts?.records?.length
        ) {
            let dynamicValueAssign = search_alldashboardproducts
            setTableValue(dynamicValueAssign?.records)
        }
    }, [action])

    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const [userModalOpen, setUserModalOpen] = useState(false)
    const [notifModalOpen, setNotifModalOpen] = useState(false)

    const statusData = {
        formik: formikStatus,
        data: [
            {
                label: 'Select Buyer status',
                placeholder: 'Select Status',
                type: 'select',
                class: 'col-12',
                options: [
                    { value: 'active', show: 'Active' },
                    { value: 'deactivated', show: 'Deactivated' },
                    { value: 'suspended', show: 'Suspended' },
                ],
                name: 'action',
            },
            {
                label: 'Reject notes',
                placeholder: 'Enter reject notes',
                type: 'text',
                class: `${
                    formikStatus.values.action === 'deactivated' ||
                    formikStatus.values.action === 'rejected'
                        ? ''
                        : 'd-none'
                } col-12`,
                name: 'reject_notes',
            },
        ],
    }

    const deleteFunction = () => {
        formikStatus.values.action = 'deleted'
        changeUserStatus(formikStatus.values)
    }

    const addMemberFunction = () => {
        let currentDate = new Date()
        let endDate = new Date()
        console.log(parseInt(currentDate.getMonth() + 1), 'guuu')
        endDate.setDate(endDate.getDate() + 30)
        userAction({
            id: single_user.record?.user_id,
            membership: 'plus_member',
            membership_date:
                currentDate.getFullYear() +
                '/' +
                parseInt(currentDate.getMonth() + 1) +
                '/' +
                currentDate.getDate(),
            membership_enddate:
                endDate.getFullYear() +
                '/' +
                parseInt(endDate.getMonth() + 1) +
                '/' +
                endDate.getDate(),
            membership_period: 'monthly',
            membership_autopay: 1,
        })
    }
    const removeMemberFunction = () => {
        userAction({
            id: single_user.record?.user_id,
            membership_autopay: 0,
        })
    }

    const userStatus = () => {
        console.log(formikStatus.values, 'alingg')
        if (formikStatus.values.action === 'suspended') {
            formikStatus.values.suspended = 1
        } else {
            formikStatus.values.suspended = 0
            formikStatus.values.additionalUpdate = true
        }
        changeUserStatus(formikStatus.values)
    }

    useEffect(() => {
        if (data.popup) {
            setUserModalOpen(false)
            setNotifModalOpen(false)
        }
    }, [data.popup])

    return (
        <>
            <div className="addUserModal">
                <div>
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <div className="buyerDetailsTab">
                            <div className="bdTop">
                                <div className="bdUser">
                                    <h2>
                                        <span className="material-icons">
                                            account_circle
                                        </span>
                                        {single_user?.record?.first_name}{' '}
                                        {single_user?.record?.last_name}
                                    </h2>
                                    {single_user?.record?.status ===
                                    'active' ? (
                                        <h6>
                                            <span className="material-icons active">
                                                check_circle
                                            </span>
                                            Active
                                        </h6>
                                    ) : single_user?.record?.status ===
                                      'deactivated' ? (
                                        <h6>
                                            <span className="material-icons deactivated">
                                                do_disturb_alt
                                            </span>
                                            Deactivated
                                        </h6>
                                    ) : (
                                        <h6>
                                            <span className="material-icons cancelled">
                                                cancel
                                            </span>
                                            Suspended
                                        </h6>
                                    )}
                                </div>
                                <div>
                                    {value === 2 ? (
                                        <Button
                                            id="invoice_report"
                                            variant="outlined"
                                            className="exportDownload"
                                            onClick={() =>
                                                getAllExportDownload({
                                                    action: 'export',
                                                    order: 'asc',
                                                    orderby: '',
                                                    search: 'all',
                                                    report: `all_invoice_management`,
                                                    filters: {
                                                        userId: {
                                                            type: 'in',
                                                            value: single_user
                                                                ?.record?.id
                                                                ? single_user
                                                                      ?.record
                                                                      ?.id
                                                                : '',
                                                            field: 'b.user_id',
                                                        },
                                                    },
                                                })
                                            }
                                        >
                                            <span className="material-icons-round">
                                                get_app
                                            </span>
                                        </Button>
                                    ) : null}

                                    <Button
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        onClick={handleMenuClick}
                                        variant="outlined"
                                    >
                                        <span className="material-icons edit">
                                            edit
                                        </span>
                                        Edit
                                        <span className="material-icons down">
                                            expand_more
                                        </span>
                                    </Button>
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                setUserModalOpen(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            Buyer Profile
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setNotifModalOpen(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            Notification Preferences
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setUserStatusOpen(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            Buyer Status
                                        </MenuItem>
                                        {/* <MenuItem
                                            onClick={() => {
                                                setDeletePopup(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            Delete Buyer
                                        </MenuItem> */}
                                        <MenuItem
                                            onClick={() => {
                                                setMembershipPopup(true)
                                                setAnchorEl(null)
                                            }}
                                        >
                                            {single_user?.record.membership ==
                                            'plus_member'
                                                ? ' Cancel Membership'
                                                : ' Add Membership'}{' '}
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </div>
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    // onChange={handleChange}
                                    aria-label="simple tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label="Account Info"
                                        value={0}
                                        onClick={() => handleChange(0)}
                                    />
                                    <Tab
                                        label="Auctions"
                                        value={1}
                                        onClick={() => handleChange(1)}
                                    />
                                    <Tab
                                        label="Bid History"
                                        value={3}
                                        onClick={() => handleChange(3)}
                                    />
                                    {props.invoiceTab ? (
                                        <Tab
                                            label="Invoices"
                                            value={2}
                                            onClick={() => handleChange(2)}
                                        />
                                    ) : null}
                                    <Tab
                                        label="Credits"
                                        value={5}
                                        onClick={() => handleChange(5)}
                                    />
                                    <Tab
                                        label="Membership Transactions"
                                        value={6}
                                        onClick={() => handleChange(6)}
                                    />

                                    {/* <Tab
                                        label="Notifications"
                                        value={2}
                                        onClick={() => handleChange(2)}
                                    /> */}
                                    <Tab
                                        label="User Logs"
                                        value={4}
                                        onClick={() => handleChange(4)}
                                    />
                                    {/* <Tab label="Notes" value={4} onClick={() => handleChange(4)} /> */}
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <>
                                    <div className="userInfoSection">
                                        <div className="uiLt">
                                            <h3>
                                                {' '}
                                                Buyer Profile{' '}
                                                {single_user?.record
                                                    ?.membership ===
                                                'plus_member' ? (
                                                    <span className="plusBadge">
                                                        <img
                                                            src="/assets/svg/crown.svg"
                                                            alt="plus member"
                                                        />
                                                        Plus Member
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </h3>

                                            <h4>
                                                <span>Name</span>
                                                {
                                                    single_user?.record
                                                        ?.first_name
                                                }{' '}
                                                {single_user?.record?.last_name}
                                            </h4>
                                            {single_user?.record?.username !==
                                                '' &&
                                            single_user?.record?.username ? (
                                                <h4>
                                                    <span>Username</span>
                                                    {
                                                        single_user?.record
                                                            ?.username
                                                    }{' '}
                                                </h4>
                                            ) : null}

                                            <h4>
                                                <span>Email</span>
                                                {
                                                    single_user?.record?.email
                                                }{' '}
                                            </h4>

                                            <h4>
                                                <span>Phone</span>
                                                {
                                                    single_user?.record?.phone
                                                }{' '}
                                            </h4>
                                            <h4>
                                                <span>Address</span>
                                                {(single_user?.record?.address1
                                                    ? `${single_user?.record?.address1}, `
                                                    : '') +
                                                    (single_user?.record
                                                        ?.address2
                                                        ? `${single_user?.record?.address2}, `
                                                        : '') +
                                                    (single_user?.record?.city
                                                        ? `${single_user?.record?.city}, `
                                                        : '') +
                                                    (single_user?.record?.state
                                                        ? `${single_user?.record?.state}, `
                                                        : '') +
                                                    (single_user?.record
                                                        ?.country
                                                        ? `${single_user?.record?.country}, `
                                                        : '') +
                                                    (single_user?.record?.zip
                                                        ? `${single_user?.record?.zip}`
                                                        : '')}
                                            </h4>
                                            <h4>
                                                <span>Joined On</span>
                                                {dateTimeFormatFunction(
                                                    single_user?.record
                                                        ?.created_at,
                                                    false,
                                                    'll'
                                                )}{' '}
                                            </h4>
                                            <h4>
                                                <span>Plus Member</span>
                                                {single_user?.record
                                                    .membership == 'plus_member'
                                                    ? 'Active Plus Member'
                                                    : 'Non Plus Member'}{' '}
                                            </h4>
                                            {single_user?.record.membership ==
                                            'plus_member' ? (
                                                <>
                                                    <h4>
                                                        <span>
                                                            Membership Start
                                                            Date
                                                        </span>
                                                        {dateTimeFormatFunction(
                                                            single_user?.record
                                                                ?.membership_date,
                                                            false,
                                                            'll'
                                                        )}{' '}
                                                    </h4>
                                                    {single_user?.record
                                                        ?.membership_autopay ? (
                                                        <h4>
                                                            <span>
                                                                Next Billing
                                                                Date
                                                            </span>
                                                            {dateTimeFormatFunction(
                                                                single_user
                                                                    ?.record
                                                                    ?.membership_enddate,
                                                                false,
                                                                'll'
                                                            )}{' '}
                                                        </h4>
                                                    ) : (
                                                        <h4>
                                                            <span>
                                                                Membership
                                                                Cancelled On
                                                            </span>
                                                            {dateTimeFormatFunction(
                                                                single_user
                                                                    ?.record
                                                                    ?.membership_enddate,
                                                                false,
                                                                'll'
                                                            )}{' '}
                                                        </h4>
                                                    )}
                                                </>
                                            ) : null}
                                            {single_user?.record?.status ==
                                            'deactivated' ? (
                                                <h4>
                                                    <span>
                                                        Deactivated Date
                                                    </span>
                                                    {single_user?.record
                                                        .deactivate_date
                                                        ? dateTimeFormatFunction(
                                                              single_user
                                                                  ?.record
                                                                  .deactivate_date
                                                          )
                                                        : ''}{' '}
                                                </h4>
                                            ) : null}

                                            {single_user?.record
                                                ?.reject_notes !== '' &&
                                            single_user?.record
                                                ?.reject_notes ? (
                                                <h4>
                                                    <span>Notes</span>
                                                    {
                                                        single_user?.record
                                                            ?.reject_notes
                                                    }{' '}
                                                </h4>
                                            ) : null}
                                        </div>
                                        <div className="uiRt">
                                            <h3>Notification Preferences</h3>

                                            <UserNotifications
                                                data={single_user?.record}
                                                cancelFunction={
                                                    notificationClose
                                                }
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-none">
                                        {' '}
                                        <BaseActionPage
                                            arrayValue={props.fieldValue}
                                            data={props.data}
                                            additionalFormikUpdate={
                                                additionalFormikUpdate
                                            }
                                            editFunction={getSingleUser}
                                            editValue={single_user}
                                            handleMapDataValue={
                                                handleMapDataValue
                                            }
                                            actionFunction={formSubmit}
                                            cancelFunction={cancelSubmit}
                                            buttonAction={buttonData}
                                            customValidation={customValidation}
                                            customInitialValues={
                                                customInitialValues
                                            }
                                            // mapDataValue={mapDataValue}
                                            // resetMapData={resetMapData}
                                            // setResetMapData={setResetMapData}
                                        />
                                    </div>
                                </>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <BuyerBids
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <UserInvoices
                                    userId={single_user?.record?.user_id}
                                    adminId={user.id}
                                    hideAction={true}
                                    hideTableAction={true}
                                    hideCompactView={true}
                                    advFilters={true}
                                />
                            </TabPanel>
                            {/* <TabPanel value={value} index={2}>
                                <UserNotifications
                                    data={single_user?.record}
                                    cancelFunction={cancelSubmit}
                                />
                            </TabPanel> */}
                            <TabPanel value={value} index={3}>
                                <UserBidHistory
                                    userId={single_user?.record?.user_id}
                                    lisingonly={props.lisingonly}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <UserLogs
                                    data={single_user?.record}
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={5}>
                                <Credits
                                    data={single_user?.record}
                                    hideCompactView={true}
                                    updateFunction={updateFunction}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={6}>
                                <MembershipLogs
                                    action={'all'}
                                    userId={single_user?.record?.user_id}
                                />
                            </TabPanel>
                        </div>
                    )}
                </div>
            </div>
            <CustomDialog
                title="Edit User"
                open={userModalOpen}
                function={() => setUserModalOpen(false)}
                className="userModal"
            >
                <BaseActionPage
                    arrayValue={props.fieldValue}
                    data={props.data}
                    additionalFormikUpdate={additionalFormikUpdate}
                    editFunction={getSingleUser}
                    editValue={single_user}
                    handleMapDataValue={handleMapDataValue}
                    actionFunction={formSubmit}
                    cancelFunction={closeUser}
                    buttonAction={buttonData}
                    customValidation={customValidation}
                    customInitialValues={customInitialValues}
                    // mapDataValue={mapDataValue}
                    // resetMapData={resetMapData}
                    // setResetMapData={setResetMapData}
                />
            </CustomDialog>
            <CustomDialog
                title="Edit Notification Preferences"
                open={notifModalOpen}
                function={() => setNotifModalOpen(false)}
                className="notifModal"
            >
                <UserNotifications
                    data={single_user?.record}
                    cancelFunction={notificationClose}
                />
            </CustomDialog>
            <CustomDialog
                title="Edit Buyer Status"
                className="userStatusModal"
                open={userStatusOpen}
                function={() => setUserStatusOpen(false)}
            >
                <form onSubmit={formikStatus.handleSubmit}>
                    <div className="row">{mapData(statusData)}</div>
                </form>
                <div className="d-flex align-items-center justify-content-end mt-4">
                    <SecondaryButton
                        label="Cancel"
                        onClick={() => setUserStatusOpen(false)}
                    />
                    <PrimaryButton
                        btnSize="ml-2"
                        label="Submit"
                        onClick={() => userStatus()}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                title="Delete Buyer"
                open={deletePopup}
                function={() => setDeletePopup(false)}
                className="deleteUserModal"
            >
                <h5>{'Are you sure you want to delete this buyer?'}</h5>
                <div className="d-flex align-items-center justify-content-end mt-4">
                    <SecondaryButton
                        label="Cancel"
                        onClick={() => setDeletePopup(false)}
                    />
                    <PrimaryButton
                        btnSize="ml-2"
                        label="Yes, Delete this buyer"
                        onClick={() => deleteFunction()}
                    />
                </div>
            </CustomDialog>
            <CustomDialog
                title={
                    single_user?.record.membership == 'plus_member'
                        ? 'Cancel Membership'
                        : 'Add Membership'
                }
                open={membershipPopup}
                function={() => setMembershipPopup(false)}
                className=""
            >
                {single_user?.record.membership == 'plus_member' ? (
                    <h5>
                        {
                            'Are you sure you want to Cancel Membership for this buyer?'
                        }
                    </h5>
                ) : (
                    <h5>
                        {
                            'Are you sure you want to Add Membership for this buyer?'
                        }
                    </h5>
                )}
                <div className="d-flex align-items-center justify-content-end mt-4">
                    <SecondaryButton
                        label="Cancel"
                        onClick={() => setMembershipPopup(false)}
                    />
                    {single_user?.record.membership == 'plus_member' ? (
                        <PrimaryButton
                            btnSize="ml-2"
                            label="Submit"
                            onClick={() => removeMemberFunction()}
                        />
                    ) : (
                        <PrimaryButton
                            btnSize="ml-2"
                            label="Submit"
                            onClick={() => addMemberFunction()}
                        />
                    )}
                </div>
            </CustomDialog>
        </>
    )
}

export default BuyerProfile
